import React, { useState } from 'react';
import { useAdminStore } from '../../../lib/store-admin';

interface CreateUserModalProps {
    institutionId: string;
    onClose: () => void;
}

export const CreateUserModal: React.FC<CreateUserModalProps> = ({ institutionId, onClose }) => {
    const { createUser } = useAdminStore();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        fullName: '',
        role: 'personel' as 'personel' | 'mudur' | 'admin'
    });

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        try {
            const result = await createUser({
                email: formData.email,
                password: formData.password,
                full_name: formData.fullName,
                role: formData.role,
                institution_id: institutionId
            });

            if (result.success) {
                onClose();
            } else {
                setError(result.error || 'Kullanıcı oluşturulamadı');
            }
        } catch (err: any) {
            setError(err.message || 'Kullanıcı oluşturulurken bir hata oluştu');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Yeni Kullanıcı Ekle</h2>
                    <button className="close-btn" onClick={onClose}>
                        <span className="material-symbols-outlined">close</span>
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="modal-form">
                    <div className="form-group">
                        <label>Ad Soyad</label>
                        <input
                            type="text"
                            value={formData.fullName}
                            onChange={e => setFormData({ ...formData, fullName: e.target.value })}
                            required
                            placeholder="Örn: Ahmet Yılmaz"
                        />
                    </div>

                    <div className="form-group">
                        <label>E-posta</label>
                        <input
                            type="email"
                            value={formData.email}
                            onChange={e => setFormData({ ...formData, email: e.target.value })}
                            required
                            placeholder="ahmet@kurum.com"
                        />
                    </div>

                    <div className="form-group">
                        <label>Şifre</label>
                        <input
                            type="text"
                            value={formData.password}
                            onChange={e => setFormData({ ...formData, password: e.target.value })}
                            required
                            placeholder="En az 6 karakter"
                            minLength={6}
                        />
                    </div>

                    <div className="form-group">
                        <label>Rol</label>
                        <select
                            value={formData.role}
                            onChange={e => setFormData({ ...formData, role: e.target.value as any })}
                        >
                            <option value="personel">Personel</option>
                            <option value="mudur">Müdür</option>
                            <option value="admin">Admin</option>
                        </select>
                    </div>

                    {error && <div className="error-message">{error}</div>}

                    <div className="modal-actions">
                        <button type="button" className="btn-secondary" onClick={onClose} disabled={isLoading}>
                            İptal
                        </button>
                        <button type="submit" className="btn-primary" disabled={isLoading}>
                            {isLoading ? 'Oluşturuluyor...' : 'Kullanıcı Oluştur'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
